<template>
  <section class="sect01">
    <div class="container sect01--wrap">
      <!-- <h2 class="tit-type sect01--maintit"><div>일반피부<span>관리방법</span></div></h2> -->
      <!-- <div class="sect01-txtwrap">
        <h3 class="sect01-tit">평소에 꾸준한 관리를 통한 동안피부의 비법</h3>
        <div class="label-type mr-2">사용 TIP</div>
        <div class="sect01-txt">오일미스트 흡수후 밸런스 젤 사용 부스터, 세럼, 부스터 순으로 흡수 후
          크림 > 썬젤 > 비비 > 쿠션으로 진행하여 오일미스트로 마무리</div>
      </div> -->
      <div class="sect01--img"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Type01',
};
</script>
